import { render, staticRenderFns } from "./protocol2.vue?vue&type=template&id=631b0480&scoped=true&"
import script from "./protocol2.vue?vue&type=script&lang=js&"
export * from "./protocol2.vue?vue&type=script&lang=js&"
import style0 from "./protocol2.vue?vue&type=style&index=0&id=631b0480&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631b0480",
  null
  
)

export default component.exports